import {KTIcon} from '../../../../_metronic/helpers'

const UserEditModalHeader = ({user, setShowEditModal}) => {
  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'>Edit Profile of {user?.displayName || user?.first_name + " " + user?.last_name}</h2>
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() =>  {
         setShowEditModal(false)
        }}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>

    </div>
  )
}

export {UserEditModalHeader}
